// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__50tbB","content":"GlobalSearch_content__bq86i"};